module.exports = __webpack_public_path__ + "static/media/st.a9db5b50.svg";